export default __webpack_public_path__ + "static/media/Vambraces of Indomitable Souls.895d8d5f.jpg";